// @flow
import FileUploadJob from './FileUploadJob';
import Upload from './Upload';
import FutureJob from '../protocol/FutureJob';
import runImportQuery from './runImportQuery';
import { ImportQueryResponse } from '../autogenerated/ZoomBridge';
import t from '../i18n/I18n';
import ConnectionUtil from "../util/session/ConnectionUtil";


const debug = require('../debug/debug')('wc:upload:AssetUploadJob');

const defaultUrlPrefix = ConnectionUtil.getPreviewServerUrl() + '/webclient/uploadFile?action=upload&uniqueKey=';

/**
 * A {@link FileUploadJob} that configures the upload url from
 * the {@link Upload} `uniqueKey`. The base url can be overridden.
 * Emits 'change' events upon receiving 'progress', 'resolve',
 * or 'reject' events from the {@link FileUploadJob}.
 */
export default class AssetUploadJob extends FutureJob {
  _fileUploadJob: FileUploadJob;
  _upload: Upload;
  _importQueryResponse: ImportQueryResponse;

  constructor(upload: Upload, url: ?string) {
    super();

    const { file, uniqueKey } = upload;
    url = url || defaultUrlPrefix + uniqueKey;
    this._fileUploadJob = new FileUploadJob(file, url);
    this._upload = upload;

    if (upload.isNameValid) {
      this._fileUploadJob.addListener('progress', (job: AssetUploadJob, e: ProgressEvent) => {
        upload.loaded = e.loaded;
        upload.total = e.total;
        this.emit('change', this);
      });

      this._fileUploadJob._promise
        .then(() => {
          upload.status = 'UPLOADED';
          this.emit('change', this);
        })
        .catch((e) => {
          upload.status = 'ERROR';
          upload.errorText = t('UPLOAD_ERROR');
          this.emit('change', this);
        });
    } else {
      this.cancel();
    }
  }

  get upload(): Upload {
    return this._upload;
  }

  get fileUploadJob(): FileUploadJob {
    return this._fileUploadJob;
  }

  get importQueryResponse(): ImportQueryResponse {
    return this._importQueryResponse;
  }

  async start() {
    try {
      this._started = true;
      this._fileUploadJob.start();
      await this._fileUploadJob.promise;
      this._importQueryResponse = await runImportQuery([this], this._upload.uniqueKey, this._upload.path);
      this.emit('resolve', this);
    } catch (err) {
      debug('[start()] error: ', err);
      this.emit('reject', this);
    }
  }

  cancel() {
    this._fileUploadJob.cancel();
    this._canceled = true;
  }
}
